/**
 * Listen to updates in online doctors and operators and update those pages,
 * if they are active.
 */
import io from "socket.io-client";
import apiConfig from "./api-config";
let socket = null;
let operatorUpdater = null;
let doctorUpdater = null;
let paymentListUpdater = null;
let socketUpdater = null;
let appointmentUpdater = null;
let signOut = null;

export function connect(token, signOutFunc) {
  console.assert(token, "token must be given");
  console.assert(signOutFunc, "signOutFunc must be given");

  console.log("Connecting websocket");
  socket = io(apiConfig.api_host, {
    query: {
      token,
      attendance: false,
    },
  });

  signOut = signOutFunc;

  socket.on("connect", () => {
    if (socketUpdater) {
      socketUpdater.online();
    }
    console.log(`Websocket connected to server ${apiConfig.api_host}`);
  });

  socket.on("disconnect", (reason) => {
    if (socketUpdater) {
      socketUpdater.offline();
    }
    console.log(`Websocket disconnected, reason: ${reason}`);
  });

  socket.on("error", (error) => {
    console.log("WebSocket error", error);
    if (error.auth) {
      console.log("JWT expired, signing out");
      signOut();
    }
  });

  socket.on("mission-billed", (mission) => {
    if (paymentListUpdater) {
      paymentListUpdater.add(mission);
    }
  });

  socket.on("mission-paid", (mission_id) => {
    if (paymentListUpdater) {
      paymentListUpdater.remove(mission_id);
    }
  });

  socket.on('doctor-available', (doctor) => {
    if (doctorUpdater) {
      doctorUpdater.add(doctor);
    }
  });

  socket.on("doctor-unavailable", (doctor_id) => {
    if (doctorUpdater) {
      doctorUpdater.remove(doctor_id);
    }
  });

  socket.on("operator-available", (operator) => {
    if (operatorUpdater) {
      operatorUpdater.add(operator);
    }
  });

  socket.on("operator-unavailable", (operator_id) => {
    if (operatorUpdater) {
      operatorUpdater.remove(operator_id);
    }
  });

  socket.on("new-appointment", (appointment) => {
    if (appointmentUpdater) {
      appointmentUpdater.add(appointment);
    }
  });

  socket.on("appointment-update", (appointment) => {
    if (appointmentUpdater) {
      appointmentUpdater.add(appointment);
    }
  });
}

export function disconnect() {
  if (socket) {
    console.log("Disconnecting websocket");
    socket.close();
    socket = null;
  }
}

export function isConnected() {
  return socket && socket.connected;
}

export function setOperatorUpdater(updater) {
  operatorUpdater = updater;
  socketUpdater = updater;
}

export function unsetOperatorUpdater() {
  operatorUpdater = null;
  socketUpdater = null;
}

export function setDoctorUpdater(updater) {
  doctorUpdater = updater;
  socketUpdater = updater;
}

export function unsetDoctorUpdater() {
  doctorUpdater = null;
  socketUpdater = null;
}

export function setPaymentListUpdater(updater) {
  paymentListUpdater = updater;
  socketUpdater = updater;
}

export function unsetPaymentListUpdater() {
  paymentListUpdater = null;
  socketUpdater = null;
}

export function setAppointmentUpdater(updater) {
  appointmentUpdater = updater;
  socketUpdater = updater;
}

export function unsetAppointmentUpdater() {
  appointmentUpdater = null;
  socketUpdater = null;
}

export default connect;



// WEBPACK FOOTER //
// ./src/utility/socket-handler.js